var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"base-container"},[_c('el-header',[_c('app-header')],1),_c('el-container',[_c('el-aside',[_c('app-nav')],1),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }